import React from "react";

const Mission = () => {
  return (
    <div className="page-content">
      <div className="mission-container">
        <div className="mission-card">
          <h2 className="section-heading">Our Mission</h2>
          <p className="mission-text">
            To make injustice visible and fight for good births, healthy moms
            and strong babies in our communities.
          </p>
        </div>
        <div className="mission-card">
          <h2 className="section-heading">Core Values</h2>
          <p className="core-values">
            Hard work, integrity, community Involvement, cultural consciousness
          </p>
        </div>
        <div className="mission-card">
          <h2 className="section-heading">Program Goals</h2>
          <ul className="mission-list">
            <li>
              To train and develop a qualified cohort of woman to help address
              birth inequities in minority populations in Nassau County in
              culturally relevant and respectful ways
            </li>
            <li>
              To motivate and encourage minority residents within Nassau County
              to become more informed participants in their birthing process
            </li>
            <li>
              To advocate for culturally relevant and respectful care from
              Nassau County health and social service providers
            </li>
            <li>
              Hearing stories of black women on Long Island about birth and
              babies
            </li>
            <li>
              Bringing high quality measures that are enriching and provide
              EQUITY in the care of our birthing moms.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Mission;
